import React, { Component } from 'react';
import '../../../App.css';

class footer extends Component {
  render() {
    return (
      <div className="footer">       
        <span>We were born to feed you</span>
        <div id="redes-footer">
          <a href="https://www.facebook.com/pioricost/" target="_blank" className="fa fa-facebook"></a>
          <a href="https://www.instagram.com/pioricostfruitec/" target="_blank" className="fa fa-instagram"></a>
        </div>
        <p id="copyright">© 2018 Pioricost. All Rights Reserved.</p>
      </div>
    );
  }
}

export default footer;


// WEBPACK FOOTER //
// ./src/components/reusables/footer/index.js